import { Estado } from "./estado";
import sesStorage from "./storage/session-storage";

export abstract class EstadoComponent<EstadoImpl extends Estado>{

    storageEstado = sesStorage;
    estado: EstadoImpl;

    constructor(type : (new() => EstadoImpl)){      
        this.estado = new type();
        this.carregarEstado();
    }

    carregarEstado() {
         const estadoEncontrado = this.storageEstado.carregarEstado<EstadoImpl>(this.estado.id);
         if(estadoEncontrado){
             this.estado = estadoEncontrado;
         }
    }

    salvarEstado(){
       this.storageEstado.salvarEstado(this.estado.id, this.estado);
    }
}